import styled from '@emotion/styled'

export const Wrapper = styled.div`
  display: flex;
  border-radius: 32px;
  padding: 16px 24px;
  background-color: white;
  align-items: flex-start;
`
